"use client";

import { useRef } from "react";
import { Shield, Thermometer, Zap } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  icon: Thermometer,
  title: "Vetted Pros",
  body: "Pros join through network onboarding. Connect with independent local contractors with confidence."
}, {
  icon: Shield,
  title: "Secure Booking",
  body: "Our platform connects you with local contractors quickly. Request estimates and confirm appointment details in one simple step."
}, {
  icon: Zap,
  title: "Local Matching",
  body: "Need help now? Our matchmaking connects you with local independent pros ready to assist with your home service needs."
}];
export default function Valuepropositiongrid() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".md-eyebrow", {
        y: 16
      });
      gsap.set(".md-heading", {
        y: 16
      });
      gsap.set(".md-intro", {
        y: 16
      });
      gsap.to([".md-eyebrow", ".md-heading", ".md-intro"], {
        opacity: 1,
        y: 0,
        duration: 0.62,
        ease: "power3.out",
        stagger: 0.09,
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      gsap.set(".md-cell", {
        y: 16
      });
      gsap.to(".md-cell", {
        opacity: 1,
        y: 0,
        duration: 0.62,
        ease: "power3.out",
        stagger: 0.11,
        scrollTrigger: {
          trigger: ".md-grid",
          start: "top 82%",
          once: true
        }
      });
      gsap.to(".md-underline", {
        scaleX: 1,
        duration: 0.42,
        ease: "power2.out",
        stagger: 0.11,
        scrollTrigger: {
          trigger: ".md-grid",
          start: "top 82%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".md-eyebrow", ".md-heading", ".md-intro", ".md-cell"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".md-underline", {
        scaleX: 1
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="32684" id="valuepropositiongrid" data-nav="light" className="bg-background text-foreground py-28 md:py-40">
      <div ref={container} className="mx-auto max-w-[1360px] px-5 sm:px-8 md:px-14">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            {}
            <div className="md-eyebrow flex items-center gap-4" style={{
            opacity: 0
          }}>
              <span aria-hidden="true" className="block h-3 w-px" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span className="font-default text-[0.8125rem] font-semibold uppercase leading-none" style={{
              color: "var(--primary)",
              letterSpacing: "0.22em"
            }}>
                Trusted Marketplace
              </span>
              <span aria-hidden="true" className="block h-3 w-px" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            {}
            <h2 className="md-heading font-mono font-bold uppercase text-foreground mt-5" style={{
            opacity: 0,
            fontSize: "clamp(2.25rem, 5.2vw, 4.75rem)",
            lineHeight: 0.95,
            letterSpacing: "-0.005em"
          }}>
              Quality service, simplified.
            </h2>

            {}
            <p className="md-intro font-default mt-7 max-w-[55ch]" style={{
            opacity: 0,
            color: "var(--muted-foreground)",
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            lineHeight: 1.6,
            letterSpacing: "-0.005em"
          }}>
              We connect homeowners with vetted local contractors. From repairs to maintenance, get the job done right with Handy Heroes.
            </p>
          </div>
        </div>

        {}
        <div className="md-grid mt-20 grid grid-cols-1 md:grid-cols-3 md:gap-8 relative">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div data-index={i} key={feature.title} className={["md-cell relative pt-6 md:pt-8 pb-6 md:pb-0 px-0 md:px-4", i > 0 ? "border-t border-border md:border-t-0" : "", i > 0 ? "md:border-l md:border-border" : ""].join(" ")} style={{
            opacity: 0
          }}>
                <Icon aria-hidden="true" className="text-foreground" strokeWidth={1.5} size={40} />
                <span aria-hidden="true" className="md-underline block mt-3 h-[2px] w-6 origin-left" style={{
              backgroundColor: "var(--primary)",
              transform: "scaleX(0)"
            }} />

                <h3 className="font-mono font-bold uppercase text-foreground mt-8" style={{
              fontSize: "clamp(1.5rem, 2.4vw, 2.125rem)",
              lineHeight: 1.05
            }}>
                  {feature.title}
                </h3>

                <p className="font-default mt-4 max-w-[40ch]" style={{
              color: "var(--muted-foreground)",
              fontSize: "clamp(1rem, 1vw, 1.0625rem)",
              lineHeight: 1.65
            }}>
                  {feature.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}